function ChartController(chartColorService, $timeout, $rootScope, $scope, $element) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.chartElement = $element.find('.chart');
    ctrl.chart = null;
    ctrl.chartDefaults = {
      chart: {
        backgroundColor: 'white',
      },
      credits: {
        enabled: false,
      },
      title: {
        text: null,
      },
      plotOptions: {
        series: {
          lineWidth: 5,
        },
        line: {
          marker: {
            symbol: 'circle',
            radius: 3,
          },
          states: {
            hover: {
              lineWidthPlus: 0,
            },
          },
        },
        pie: {
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
          colors: chartColorService.getAllColors(),
        },
        area: {
          marker: {
            symbol: 'circle',
            radius: 3,
          },
          states: {
            hover: {
              lineWidthPlus: 0,
            },
          },
          fillOpacity: 0,
        },
      },
      tooltip: {
        shared: true,
        crosshairs: true,
        pointFormatter: function(a, b, c) {
          return (
            '<span style="color:' +
            this.color +
            '">●</span> ' +
            this.series.name +
            ': <b>' +
            +(Math.round(this.y + 'e+3') + 'e-3') +
            '</b><br/>'
          );
        },
      },
      xAxis: {
        lineWidth: 1.5,
        gridLineWidth: 1,
        gridLineColor: '#002C65',
        tickWidth: 2,
        tickLength: 4,
        tickColor: '#002C65',
        labels: {
          style: {
            color: '#002C65',
            'font-weight': 500,
            'font-size': '14px',
          },
        },
      },
      yAxis: {
        lineWidth: 1.5,
        gridLineWidth: 1,
        gridLineColor: '#002C65',
        tickWidth: 2,
        tickLength: 4,
        tickColor: '#002C65',
        labels: {
          style: {
            color: '#002C65',
            'font-weight': 500,
            'font-size': '14px',
          },
        },
        min: 0,
      },
      exporting: {
        chartOptions: {
          chart: {
            backgroundColor: 'white',
          },
        },
        fallbackToExportServer: false,
      },
    };
    ctrl.reloadChartWatcher();
    ctrl.reflowChartWatcher();
    ctrl.initChart(ctrl.config);
  };

  ctrl.$onChanges = () => {
    if (ctrl.chartElement) {
      if (!angular.equals(ctrl.config, ctrl.previousConfig)) {
        ctrl.initChart(ctrl.config);
        ctrl.previousConfig = angular.copy(ctrl.config);
      }
      if (!angular.equals(ctrl.series, ctrl.previousSeries)) {
        if (ctrl.processSeries()) {
          ctrl.chart.redraw();
          ctrl.previousSeries = angular.copy(ctrl.series);
        }
      }
    }
  };

  ctrl.reflowChartWatcher = () => {
    let unbind = $rootScope.$on('reflowChart', function() {
      if (ctrl.chart) {
        $timeout(function() {
          ctrl.chart.reflow();
        }, 0);
      }
    });
    $scope.$on('$destroy', unbind);
  };

  ctrl.reloadChartWatcher = () => {
    let unbind = $rootScope.$on('reloadChart', function() {
      ctrl.initChart(ctrl.config);
    });
    $scope.$on('$destroy', unbind);
  };

  ctrl.resizeWatcher = () => {
    let unbind = $rootScope.$on('window-resize', function() {
      if (chart) {
        // TODO: if this causes problems in future, some sort of refresher filter might help to prevent too many reflow calls
        $timeout(function() {
          chart.reflow();
        }, 500);
      }
    });
    $scope.$on('$destroy', unbind);
  };

  ctrl.initChart = config => {
    ctrl.config = config || {};
    ctrl.config = angular.copy(config);

    let options = Highcharts.merge(ctrl.chartDefaults, {
      chart: {
        renderTo: ctrl.chartElement[0],
      },
    });

    options = Highcharts.merge(options, config.options);

    delete config.options;

    options = Highcharts.merge(options, config);

    ctrl.chart = new Highcharts.Chart(options);

    
    $timeout(function() {
      ctrl.chart.reflow();
    }, 0);
  };

  ctrl.processSeries = () => {
    if (!ctrl.chart) return;

    let usedIds = [];

    _.each(ctrl.series, function(serie) {
      let id = serie.id;
      let chartSeries = ctrl.chart.get(id);

      usedIds.push(id);

      if (chartSeries) {
        chartSeries.update(angular.copy(serie), false);
      } else {
        ctrl.chart.addSeries(angular.copy(serie), false);
      }
    });

    let serie;

    for (let i = ctrl.chart.series.length - 1; i >= 0; i--) {
      serie = ctrl.chart.series[i];

      if (usedIds.indexOf(serie.options.id) === -1) {
        serie.remove(false);
      }
    }

    return true;
  };
}

angular.module('chart.module').controller('ChartController', ChartController);
